import { forwardRef } from 'react';
import LinkInternal from './link-internal';
var Link = forwardRef(LinkInternal);
export default Link;
